(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function applyTouchMode(swiper) {
    var desktop = isDesktop();
    swiper.allowTouchMove = !desktop;
    swiper.params.simulateTouch = !desktop;
    swiper.params.grabCursor = !desktop;

    if (swiper.params.freeMode) {
      swiper.params.freeMode.enabled = !desktop;
    }

    swiper.update();
  }

  function upgradeUpsellForms(root) {
    (root || document).querySelectorAll('.kv-cro-complementary product-form').forEach(function (form) {
      if (typeof customElements !== 'undefined' && customElements.get('product-form')) {
        customElements.upgrade(form);
      }
    });
  }

  function initKvUpsellSliders(scope) {
    var root = scope || document;
    upgradeUpsellForms(root);

    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('.js-kv-upsell-swiper').forEach(function (el) {
      if (el.swiper) return;

      var complementary = el.closest('.kv-cro-complementary');
      var nav = complementary && complementary.querySelector('.kv-cro-upsell-slider__nav--header');
      var prev = nav && nav.querySelector('.kv-cro-upsell-slider__btn--prev');
      var next = nav && nav.querySelector('.kv-cro-upsell-slider__btn--next');
      var slideCount = el.querySelectorAll('.swiper-slide').length;

      if (nav) {
        nav.hidden = slideCount <= 1;
      }

      if (slideCount <= 1) return;

      var swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        grabCursor: !isDesktop(),
        simulateTouch: !isDesktop(),
        allowTouchMove: !isDesktop(),
        touchStartPreventDefault: false,
        passiveListeners: true,
        resistanceRatio: 0.85,
        freeMode: {
          enabled: !isDesktop(),
          momentum: true,
          momentumRatio: 0.85,
        },
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        watchOverflow: true,
        breakpoints: {
          750: {
            allowTouchMove: false,
            simulateTouch: false,
            grabCursor: false,
            freeMode: false,
          },
        },
      });

      applyTouchMode(swiper);

      if (!DESKTOP_MQ.__kvUpsellBound) {
        DESKTOP_MQ.__kvUpsellBound = true;
        DESKTOP_MQ.addEventListener('change', function () {
          document.querySelectorAll('.js-kv-upsell-swiper').forEach(function (sliderEl) {
            if (sliderEl.swiper) applyTouchMode(sliderEl.swiper);
          });
        });
      }
    });
  }

  function observeUpsellRecommendations() {
    document.querySelectorAll('product-recommendations.kv-cro-upsell-recommendations').forEach(function (el) {
      if (el.dataset.kvUpsellObserved) return;
      el.dataset.kvUpsellObserved = 'true';

      new MutationObserver(function () {
        initKvUpsellSliders(el);
      }).observe(el, { childList: true, subtree: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initKvUpsellSliders();
    observeUpsellRecommendations();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initKvUpsellSliders(event.target);
    observeUpsellRecommendations();
  });

  window.initKvUpsellSliders = initKvUpsellSliders;
})();
